import { Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { quotesOptions } from '../MyCustomers/Settings/components/data/quotesOptions';
import { colors } from '../../styles/theme/colors';

type ProfileFavouriteQuoteProps = { quoteId: number } & TypographyProps;

export function ProfileFavouriteQuote({ quoteId, sx, ...props }: ProfileFavouriteQuoteProps) {
    if (!quoteId) {
        return null;
    }

    const quote = quotesOptions.find((item) => item.value === quoteId);

    if (!quote) {
        return null;
    }

    return (
        <Typography
            component="blockquote"
            sx={{
                fontFamily: 'Noto Sans',
                fontSize: '18px',
                fontStyle: 'italic',
                fontWeight: 300,
                lineHeight: '25px',
                letterSpacing: 0,
                textAlign: 'left',
                color: colors.gray3,
                ...sx,
            }}
            {...props}
        >
            {quote?.label}
        </Typography>
    );
}
